<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        xs="12"
        sm="6" offset-sm="2"
        md="4" offset-md="4"
        lg="4" offset-lg="4"
        xl="4" offset-xl="4">
        <v-card
          class="mx-auto"
        >
          <v-card-title>
            {{ $$t('title') }}
          </v-card-title>
          <v-card-text>
            <v-alert type="success" :value="true" color="blue">
              <h3>{{ $$t('Blue') }}</h3>
              <div v-html="$$t('Blue-description')" />
            </v-alert>
            <v-alert type="success" :value="true" light>
              <h3>{{ $$t('Green') }}</h3>
              <div v-html="$$t('Green-description')" />
            </v-alert>
            <v-alert type="warning" class="yellow lighten-2" :value="true">
              <h3>{{ $$t('Yellow') }}</h3>
              <div v-html="$$t('Yellow-description')" />
            </v-alert>
            <v-alert type="warning" :value="true">
              <h3>{{ $$t('Orange') }}</h3>
              <div v-html="$$t('Orange-description')" />
            </v-alert>
            <v-alert type="error" :value="true">
              <h3>{{ $$t('Red') }}</h3>
              <div v-html="$$t('Red-description')" />
            </v-alert>
            <v-alert :icon="mdiAlertDecagram" type="black" class="white--text">
              <h3>{{ $$t('Black') }}</h3>
              <div v-html="$$t('Black-description')" />
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <back-button />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mdiAlertDecagram } from '@mdi/js';
import BackButton from '../components/BackButton.vue';

export default {
  name: 'Readiness',
  module: 'Membership',
  components: {
    BackButton,
  },
  data() {
    return {
      mdiAlertDecagram,
    };
  },
};
</script>
